<nav class="navbar navbar-expand-lg navbar-light bg-light">
    <a class="navbar-brand" href="#"><img src="assets/img/logo.png" style="cursor: pointer"></a>

    <div class="collapse navbar-collapse">
      <ul class="navbar-nav mr-auto">
        <li class="nav-item">
          <app-nav-link [text]="'navigation.about'" (click)="goToAbout()"></app-nav-link>
        </li>
        <li class="nav-item">
          <app-nav-link [text]="'navigation.catalog'" (click)="goToCatalog()"></app-nav-link>
        </li>
        <li class="nav-item">
          <app-nav-link [text]="'navigation.channel'" (click)="goToChannel()"></app-nav-link>
        </li>
        <li class="nav-item">
          <app-nav-link [text]="'navigation.contact'" (click)="goToContact()"></app-nav-link>
        </li>
        <li class="nav-item ml-10">
          <app-language-picker></app-language-picker>
        </li>
        <li class="nav-item ml-3">
          <app-nav-link [text]="'navigation.login'" [linkTo]="'#'" [isLogin]="'true'" (login)="handleLoggedIn()"></app-nav-link>
        </li>
      </ul>
    </div>

  </nav>
